/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('TestNotesServiceApi', ($http, ApiErrorService) => {
    return {
        unreadTestNotesCount: unreadTestNotesCount,
        unreadTestNotes: unreadTestNotes,
        addNoteNotification: addNoteNotification,
        resolve: resolve,
        testDetails: testDetails
    };
    function unreadTestNotesCount() {
        return $http.get(`api/TestNotes/UnreadTestNotesCount`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function unreadTestNotes() {
        return $http.get(`api/TestNotes/UnreadTestNotes`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function addNoteNotification(noteId, testId, note, projectIterationId) {
        return $http.post(`api/TestNotes/AddNoteNotification?noteId=${noteId}&testId=${testId}&note=${encodeURIComponent(note)}&projectIterationId=${projectIterationId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function resolve(sysMsgId) {
        return $http.post(`api/TestNotes/Resolve?sysMsgId=${sysMsgId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function testDetails(traceId) {
        return $http.get(`api/TestNotes/TestDetails?traceId=${traceId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
